module.exports = __webpack_public_path__ + "media/images/icons/caret-right-0a907bc7bfdae3821b8d0b599e4e7d7a.svg";